/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Panel, PanelBody, PanelHeader } from '../../../util/panel';
import { Row, Col, Table, DatePicker, Input, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { FaDownload } from 'react-icons/fa';
import usePaginationHook from '../../../../utils/usePagination';
import { Controller, useForm, useWatch } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import 'dayjs/locale/th';
import fitCheckingServices from '../../../../services/fit-checking.services';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { FiArrowLeft } from 'react-icons/fi';
import moment from 'moment';

const pageSize = 10;

const CheckinBranchSummaryPage = () => {
  const history = useHistory();
  const { branchId } = useParams();
  const [summary, setSummary] = useState(null);
  const [loadingExcel, setLoadingExcel] = useState(false);

  const { mutate: downloadExcel } =
    fitCheckingServices.useMutationDownloadBranchHistory2Excel(() => {
      setTimeout(() => setLoadingExcel(false), 600);
    });

  const {
    data: historyLists,
    setData,
    page,
    setPage,
    total,
    setTotal,
  } = usePaginationHook();

  const { control } = useForm({
    defaultValues: {
      dateRange: [moment().startOf('month'), moment().endOf('month')],
      searchText: '',
    },
  });

  const filterDateRange = useWatch({ control, name: 'dateRange' });
  const searchText = useWatch({ control, name: 'searchText' });

  const startDate = filterDateRange?.[0]
    ? filterDateRange[0].format('DD/MM/YYYY')
    : undefined;
  const endDate = filterDateRange?.[1]
    ? filterDateRange[1].format('DD/MM/YYYY')
    : undefined;

  fitCheckingServices.useQueryGetBranchSummary2(
    { branchId, startDate, endDate },
    (data) => {
      setSummary(data);
    },
  );

  fitCheckingServices.useQueryGetBranchHistories2(
    {
      branchId,
      take: pageSize,
      page,
      startDate,
      endDate,
      searchText,
    },
    (data) => {
      setData(data.data);
      setTotal(data.meta.total);
    },
  );

  const columns = [
    {
      title: 'NO',
      dataIndex: 'index',
      key: 'index',
      render: (_, _record, index) => (
        <span>{(page - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      title: 'รหัสนักธุรกิจ',
      dataIndex: 'memberCode',
      key: 'memberCode',
      render: (_, record) => <span>{record.memberCode || '-'}</span>,
    },
    {
      title: 'ชื่อ-สกุล',
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => (
        <div>
          <div>
            {record.userProfile?.FirstNameTh || '-'}{' '}
            {record.userProfile?.SurNameTh || '-'}
          </div>
          {record.marriedProfile?.FirstNameTh && (
            <div style={{ fontSize: 12, color: '#888' }}>
              {record.marriedProfile.FirstNameTh}{' '}
              {record.marriedProfile.SurNameTh}
            </div>
          )}
        </div>
      ),
    },
    {
      title: 'ประเภทนักธุรกิจ',
      dataIndex: 'memberType',
      key: 'memberType',
      render: (_, record) => (
        <span>
          {record.memberType === 'Distributor' && 'นักธุรกิจ'}
          {record.memberType === 'Member' && 'VIP Member'}
        </span>
      ),
    },
    {
      title: 'องค์กร',
      dataIndex: 'teamName',
      key: 'teamName',
      render: (_, record) => <span>{record.userProfile.TeamName || '-'}</span>,
    },
    {
      title: 'เช็คอินเมื่อ',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (_, record) => (
        <span>
          {record.createdAt
            ? moment(record.createdAt).format('DD/MM/YYYY HH:mm')
            : '-'}
        </span>
      ),
      sorter: (a, b) =>
        moment(a.createdAt).diff(moment(b.createdAt), 'D') > 0 ? 1 : -1,
    },
  ];

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <h3
          onClick={() => {
            history.goBack();
          }}
          className="mr-2"
          style={{ cursor: 'pointer' }}
        >
          <FiArrowLeft />
        </h3>
      </div>
      <Panel>
        <PanelHeader>สรุปยอดเช็คอินสาขา</PanelHeader>
        <PanelBody>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 16,
            }}
          >
            <div style={{ display: 'flex', gap: 12 }}>
              <Controller
                name="dateRange"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <DatePicker.RangePicker
                    placeholder={['วันที่เริ่มต้น', 'วันที่สิ้นสุด']}
                    value={value}
                    onChange={(dates) => {
                      onChange(dates);
                      setPage(1);
                    }}
                    format="DD/MM/YYYY"
                    style={{ width: 300 }}
                  />
                )}
              />
              <Controller
                name="searchText"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Input
                    placeholder="ค้นหารหัส, ชื่อ, สกุล"
                    prefix={<SearchOutlined />}
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                      setPage(1);
                    }}
                    style={{ width: 350 }}
                    allowClear
                  />
                )}
              />
            </div>
            <Button
              onClick={() => {
                setLoadingExcel(true);
                downloadExcel({
                  branchId,
                  startDate,
                  endDate,
                  searchText,
                });
              }}
              loading={loadingExcel}
              type="primary"
            >
              <FaDownload className="mr-2" />
              โหลด excel
            </Button>
          </div>

          <div style={{ marginBottom: 24 }}>
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <div
                  style={{
                    backgroundColor: '#eef3ff',
                    borderRadius: 8,
                    padding: 16,
                    textAlign: 'center',
                  }}
                >
                  <div
                    style={{
                      fontSize: 14,
                      color: '#666',
                      marginBottom: 8,
                    }}
                  >
                    ยอดเช็คอินทั้งหมด
                  </div>
                  <div
                    style={{
                      fontSize: 28,
                      fontWeight: 'bold',
                      color: '#3391ff',
                    }}
                  >
                    {summary?.totalCheckins || 0}
                  </div>
                  <div style={{ fontSize: 12, color: '#999' }}>ครั้ง</div>
                </div>
              </Col>
              <Col span={8}>
                <div
                  style={{
                    border: '1px solid #13C2C2',
                    borderRadius: 8,
                    padding: 16,
                    textAlign: 'center',
                  }}
                >
                  <div
                    style={{
                      fontSize: 14,
                      color: '#666',
                      marginBottom: 8,
                    }}
                  >
                    นักธุรกิจ
                  </div>
                  <div style={{ fontSize: 28, fontWeight: 'bold' }}>
                    {summary?.totalDistributors || 0}
                  </div>
                  <div style={{ fontSize: 12, color: '#999' }}>ครั้ง</div>
                </div>
              </Col>
              <Col span={8}>
                <div
                  style={{
                    border: '1px solid #13C2C2',
                    borderRadius: 8,
                    padding: 16,
                    textAlign: 'center',
                  }}
                >
                  <div
                    style={{
                      fontSize: 14,
                      color: '#666',
                      marginBottom: 8,
                    }}
                  >
                    VIP Member
                  </div>
                  <div style={{ fontSize: 28, fontWeight: 'bold' }}>
                    {summary?.totalMembers || 0}
                  </div>
                  <div style={{ fontSize: 12, color: '#999' }}>ครั้ง</div>
                </div>
              </Col>
            </Row>
          </div>

          <Table
            columns={columns}
            dataSource={historyLists}
            style={{ backgroundColor: '#fff' }}
            rowKey="id"
            scroll={{ x: 'max-content' }}
            onChange={({ current }) => {
              setPage(current);
            }}
            pagination={{
              pageSize,
              total,
            }}
          />
        </PanelBody>
      </Panel>
    </>
  );
};

export default CheckinBranchSummaryPage;
